
import { IGetCurrentUserDetailsQueryResponseDto } from '../../Services/ClientProxy/clientProxy';
import { GetUserPreferenceResponse, RecipientNotificationPreferenceRequestDto, ApiException } from '../../Services/ClientProxy/NotificationManagementClient';

export const LOAD_CURRENT_PROFILE = 'LOAD_CURRENT_PROFILE';
export const SAVE_CURRENT_PROFILE = 'SAVE_CURRENT_PROFILE';
export const CANCEL_MODIFICATION = 'CANCEL_MODIFICATION';
export const LOAD_CURRENT_NOTIFICATIONS = 'LOAD_CURRENT_NOTIFICATIONS';
export const SAVE_CURRENT_NOTIFICATIONS = 'SAVE_CURRENT_NOTIFICATIONS';

export interface SaveCurrentNotificationResult{
    Notification?: RecipientNotificationPreferenceRequestDto;
    lastError?: ApiException;
}
export interface SaveCurrentProfileAction {
    type: typeof SAVE_CURRENT_PROFILE;
    payload: IGetCurrentUserDetailsQueryResponseDto;
}
export interface LoadCurrentProfileAction {
    type: typeof LOAD_CURRENT_PROFILE;
    payload: IGetCurrentUserDetailsQueryResponseDto;
}
export interface CancelModificationAction {
    type: typeof CANCEL_MODIFICATION;
}

export interface SaveCurrentNotifications {
    type: typeof SAVE_CURRENT_NOTIFICATIONS;
    payload: SaveCurrentNotificationResult;
}
export interface LoadCurrentNotifications {
    type: typeof LOAD_CURRENT_NOTIFICATIONS;
    payload: GetUserPreferenceResponse;
}

export type ProfileActionTypes =
    | SaveCurrentProfileAction
    | LoadCurrentProfileAction
    | CancelModificationAction
    | SaveCurrentNotifications
    | LoadCurrentNotifications;
